import angular from 'angular';
import ongCardSwitchComponent from './ongCardSwitch.component';

let ongCardSwitchModule = angular.module('solidarity.ongCardSwitch', [
])

.component('ongCardSwitch', ongCardSwitchComponent)

.name;

export default ongCardSwitchModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCardSwitch/ongCardSwitch.js